<template>
  <div>
    <v-container pa-0 fluid>
      <v-row align="center" justify="space-between" class="font-weight-black Barra_Breadcrumbs">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="1" class="text-right" style="margin-top: -4em;">
          <v-icon v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>
    </v-container>

    <apuracao-contrato-cancelar-lote-industria-filtros
      v-model="abrirFiltro"
      @ApuracaoContratoCancelarLoteFiltros__AplicaFiltros="aplicarFiltros"
      @ApuracaoContratoCancelarLoteFiltros_conteinerCarregado="conteinerCarregado">
    </apuracao-contrato-cancelar-lote-industria-filtros>

    <v-container pa-0 mt-3 fluid v-resize="onResize" :style="`height: ${alturaCorpo}px; overflow-y: auto;`">
      <v-expansion-panels>
        <v-expansion-panel v-for="(contrato, i) in contratos"
            :key="i">
          <v-expansion-panel-header>
              <span class="subheading">{{`${$tc('label.contrato', 1)} ${contrato.idContrato} :: ${contrato.focoContrato}`}}</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <apuracao-contrato-cancelar-lote-industria-tabela
              :ref="`tabelaApuracoes_${contrato.idContrato}`"
              :id-contrato="contrato.idContrato"
              :filtros="filtros"
              :visao-status="idContrato === undefined"
              @ApuracaoContratoCancelarLoteIndustriaTabela__apuracoesSelecionadas="apuracoesSelecionadas">
            </apuracao-contrato-cancelar-lote-industria-tabela>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <p v-if="mostrarNaoEncontrado" class="text-xs-center">{{ $t('label.tabela_sem_conteudo') }}</p>

      <div id="ApuracaoContratoCancelarLote__Rodape" class="ApuracaoContratoCancelarLote__Rodape pa-2"
             :style="`width: ${tamanhoRodape}px`">
        <v-col :cols="xs ? 12 : 6">
          <v-pagination
            v-if="totalPagina > 1"
            v-model="numeroPagina"
            :length="totalPagina"
            :total-visible="$vuetify.breakpoint.mdAndUp ? 9 : 5"
            @input="buscarContratos(filtros)">
          </v-pagination>
        </v-col>
        <v-spacer v-if="!xs"></v-spacer>
        <v-btn v-show="temApuracaoSelecionada" @click="abrirModalJustificativaCancelarSelecionadas" class="mr-2 my-auto">{{ $t('label.cancelar_selecionados') }}</v-btn>
        <v-btn color="primary" v-if="contratos.length" @click="abrirModalJustificativaCancelarTudo" class="my-auto">{{ $t('label.cancelar_tudo') }}</v-btn>
      </div>
    </v-container>

    <apuracao-contrato-cancelar-lote-industria-modal-justificativa
      ref="modalJustificativa"
      :title="tituloJustificativa"
      :message="mensagemJustificativa"
      @agree="callback"/>

  </div>
</template>

<script>
import ApuracaoContratoCancelarLoteIndustriaFiltros from './ApuracaoContratoCancelarLoteIndustriaFiltros';
import { buscarTotalApuradoPorContrato } from '../../../common/resources/apuracao/apuracao-contrato';
import { getMoney } from '../../../common/functions/helpers';
import ApuracaoContratoCancelarLoteIndustriaTabela from './ApuracaoContratoCancelarLoteIndustriaTabela';
import ApuracaoContratoCancelarLoteIndustriaModalJustificativa from './ApuracaoContratoCancelarLoteIndustriaModalJustificativa';

export default {
  name: 'ApuracaoContratoCancelarLoteIndustria',
  components: {
    ApuracaoContratoCancelarLoteIndustriaTabela,
    ApuracaoContratoCancelarLoteIndustriaModalJustificativa,
    ApuracaoContratoCancelarLoteIndustriaFiltros,
  },
  data() {
    return {
      workflowApuracaoAcaoResource: this.$api.workflowApuracaoAcao(this.$resource),
      resource: this.$api.apuracaoContrato(this.$resource),
      abrirFiltro: false,
      idContrato: null,
      contratos: [],
      temApuracaoSelecionada: false,
      totalPagina: 1,
      tamanhoPagina: 10,
      numeroPagina: 1,
      filtros: {},
      tamanhoTela: window.innerWidth,
      tamanhoFiltros: 0,
      alturaTela: window.innerHeight,
      alturaRodaPe: 0,
      eventoClickCheckbox: null,
      jaBuscou: false,
      mensagemErro: '',
      fechamentoParcial: false,
      contratosCancelar: null,
      tituloJustificativa: '',
      mensagemJustificativa: '',
      callback: () => {},
      idApuracoesSelecionadas: {},
      idTodasApuracoes: [],
    };
  },
  computed: {
    alturaCorpo() {
      return this.alturaTela - 150 - this.alturaRodaPe;
    },
    tamanhoRodape() {
      return this.tamanhoTela - (this.abrirFiltro && this.lg ? this.tamanhoFiltros : 0);
    },
    xs() {
      return this.$vuetify.breakpoint.xs;
    },
    lg() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    mostrarNaoEncontrado() {
      return !this.contratos.length && this.jaBuscou;
    },
  },
  methods: {
    apuracoesSelecionadas(apuracoes, idContrato) {
      const apuracoesSelecionadas = apuracoes.map((apuracao) => apuracao.idApuracao);
      if (apuracoes && apuracoes.length) {
        this.idApuracoesSelecionadas[idContrato] = {
          apuracoesSelecionadas,
        };
      } else {
        delete this.idApuracoesSelecionadas[idContrato];
      }
      this.temApuracaoSelecionada = !!Object.keys(this.idApuracoesSelecionadas).length;
    },
    cancelarTudo(observacao) {
      this.$refs.modalJustificativa.close();
      const params = {
        idsApuracao: this.idTodasApuracoes,
        observacao,
      };
      this.cancelar(params, observacao);
    },
    cancelarSelecionados(observacao) {
      this.$refs.modalJustificativa.close();
      const idApuracoes = [];
      Object.keys(this.idApuracoesSelecionadas).forEach((id) => {
        this.idApuracoesSelecionadas[id].apuracoesSelecionadas.forEach((idApuracao) => {
          idApuracoes.push(idApuracao);
        });
      });
      const params = {
        idsApuracao: idApuracoes,
        observacao,
      };
      this.cancelar(params, observacao);
    },
    abrirModalJustificativaCancelarSelecionadas() {
      this.tituloJustificativa = this.$t('message.cancelamento_modal_titulo_selecionadas');
      this.mensagemJustificativa = this.$t('message.cancelamento_modal_mensagem_selecionadas');
      this.callback = this.cancelarSelecionados;
      this.$refs.modalJustificativa.open();
    },
    abrirModalJustificativaCancelarTudo() {
      this.tituloJustificativa = this.$t('message.cancelamento_modal_titulo_tudo');
      this.mensagemJustificativa = this.$t('message.cancelamento_modal_mensagem_tudo');
      this.callback = this.cancelarTudo;
      this.idTodasApuracoes = [];
      const idContratos = this.contratos.map((c) => c.idContrato);
      idContratos.forEach((idContrato) => {
        const ref = `tabelaApuracoes_${idContrato}`;
        this.$refs[ref][0].getApuracoes().map((a) => a.idApuracao)
          .forEach((a) => this.idTodasApuracoes.push(a));
      }, this);
      this.$refs.modalJustificativa.open();
    },
    cancelar(params) {
      this.workflowApuracaoAcaoResource.cancelarLote(params)
        .then(() => {
          this.$toast(this.$t('message.apuracoes_canceladas'));
          this.aplicarFiltros(this.filtros);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    onResize() {
      this.alturaRodaPe = document.getElementById('ApuracaoContratoCancelarLote__Rodape').offsetHeight;
      this.tamanhoTela = window.innerWidth;
      this.alturaTela = window.innerHeight;
    },
    getMoney,
    aplicarFiltros(filtros) {
      this.numeroPagina = 1;
      this.contratos = [];
      this.buscarContratos(filtros);
    },
    limparArraysControladores() {
      this.acoesSelecionadas = [];
      this.temApuracaoSelecionada = false;
      this.contratosCancelar = null;
    },
    buscarContratos(filtros) {
      filtros.tamanhoPagina = this.tamanhoPagina;
      filtros.numeroPagina = this.numeroPagina;
      this.filtros = filtros;
      return buscarTotalApuradoPorContrato(filtros, this.$resource)
        .then((response) => {
          this.contratos = response.data.resposta;
          this.limparArraysControladores();
          this.totalPagina = Math.ceil(response.data.quantidadeRegistrosPagina / this.tamanhoPagina);
          this.jaBuscou = true;
        })
        .catch((err) => {
          this.$error(this, err);
          this.jaBuscou = true;
        });
    },
    conteinerCarregado() {
      this.tamanhoFiltros = document.getElementById('ApuracaoContratoCancelarLoteFiltros__filtro_rapido').offsetWidth;
    },
  },
  beforeMount() {
    this.idContrato = this.$router.currentRoute.params.idContrato;
  },
  mounted() {
    this.alturaRodaPe = document.getElementById('ApuracaoContratoCancelarLote__Rodape').offsetHeight;
    this.abrirFiltro = true;
  },
};
</script>

<style scoped>
  .ApuracaoContratoCancelarLote__Rodape {
    display: flex;

    position: fixed;
    z-index: 2;
    transform: translate(0);
    transition: all .4s cubic-bezier(.25,.8,.5,1);
    bottom: 0px;
    left: 0;
  }
</style>
